import * as React from "react";
const NonFoodItemsIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#non-food-items_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45 7H11a4 4 0 0 0-4 4v34a4 4 0 0 0 4 4h34a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4ZM25 36.5a1.507 1.507 0 0 1-1.14 1.46 1.47 1.47 0 0 1-.36.04 1.511 1.511 0 0 1-1.33-.8L16 25.54V36.5a1.5 1.5 0 1 1-3 0v-17a1.507 1.507 0 0 1 1.14-1.46 1.523 1.523 0 0 1 1.69.76L22 30.46V19.5a1.5 1.5 0 1 1 3 0v17ZM35.5 26a1.5 1.5 0 1 1 0 3H31v7.5a1.5 1.5 0 1 1-3 0v-17a1.499 1.499 0 0 1 1.5-1.5h6a1.5 1.5 0 1 1 0 3H31v5h4.5ZM43 36.5a1.5 1.5 0 1 1-3 0v-17a1.5 1.5 0 1 1 3 0v17Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "non-food-items_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default NonFoodItemsIcon;